import React from 'react';

import { Box } from '@mui/material';

import ListPage from '../../../sharedModules/listPage/ListPage';

const XoiQuoteRecordsListPage: React.FC = () => {
  const appModuleColumns = [
    {
      name: 'Created At',
      selector: 'created_at_display',
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: 'Account No',
      selector: 'acct_no',
      sortable: true,
      grow: 1,
    },
  ];

  return (
    <ListPage
      clickableRows
      columns={appModuleColumns}
      controller="admin/xoi_quote_records"
      queryPlaceholder="Filter by module name..."
      title="XOI Quote Records"
    />
  );
};

export default XoiQuoteRecordsListPage;
